function onDialogMainAction() {}

export default onDialogMainAction;
